import { useEffect } from 'react';

// Invokes onOutside on any click/tap outside the ref's element. Capture-phase
// pointerdown so it fires even when the target stops propagation or unmounts
// on click. Pass active: false to skip listening entirely (e.g. while a
// dropdown is closed) so closed components register no document listeners.
const useOutsideClick = (ref, onOutside, active = true) => {
  useEffect(() => {
    if (!active) return undefined;

    const handlePointerDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside(e);
    };

    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [ref, onOutside, active]);
};

export default useOutsideClick;
